exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nth[data-v-0979d410] {\n  padding: 5px;\n}\n.content-tlist[data-v-0979d410] {\n  overflow: scroll;\n  max-width: 1500px;\n  max-height: 100vh;\n}\n.content-table td div[data-v-0979d410] {\n  overflow: visible !important;\n}\n", ""]);

// exports
